/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { PROMPT_TYPES, PM_SETTINGS_KEY } from "../../../utility/constants";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin promptsManager/utility/lookupHelper";

// Language -------------------------------------------------------------------
export const getLanguageList = (languageArr) => {
	let languageList = {};

	languageArr.forEach((lang) => {
		languageList = {
			...languageList,
			[lang]: lang,
		};
	});

	return languageList;
};

export const getLanguageSelectArr = (languageArr) => {
	const languageSelectArr = [];

	languageArr.forEach((lang) => {
		const newSelectLanguage = {
			label: lang,
			value: lang,
		};
		languageSelectArr.push(newSelectLanguage);
	});

	return languageSelectArr;
};

// Namespace ------------------------------------------------------------------
export const getNamespaceList = (namespaceArr) => {
	let namespaceList = {};

	namespaceArr.forEach((ns) => {
		namespaceList = {
			...namespaceList,
			[ns]: ns,
		};
	});

	return namespaceList;
};

export const getNamespaceSelectArr = (namespaceArr) => {
	const namespaceSelectArr = [];

	namespaceArr.forEach((ns) => {
		const newSelectNamespace = {
			label: ns,
			value: ns,
		};
		namespaceSelectArr.push(newSelectNamespace);
	});

	return namespaceSelectArr;
};

// PromptType -----------------------------------------------------------------
export const getPromptTypeList = () =>
	PROMPT_TYPES.reduce((res, prompt) => {
		res[prompt.value] = prompt.value;
		return res;
	}, {});

export const getPromptTypeSelectArr = () => PROMPT_TYPES;

export const fetchPromptSettings = () => {
	// Check browser support
	if (typeof Storage === "undefined") {
		v2.warn("localStorage is not supported!", { logCode: errorCodes.LOCAL_STORAGE_SUPPORT_WARNING });
		return;
	}

	try {
		const storageSettings = localStorage.getItem(PM_SETTINGS_KEY) || "{}";
		return JSON.parse(storageSettings);
	} catch (error) {
		v2.error("Error while loading prompt settings from local storage", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.LOAD_PROMPT_SETTINGS_ERROR,
		});
		return {};
	}
};

export const savePromptsSettings = (settings) => {
	// Check browser support
	if (typeof Storage === "undefined") {
		v2.warn("localStorage is not supported!", { logCode: errorCodes.LOCAL_STORAGE_SUPPORT_WARNING });
		return;
	}

	const settingsString = JSON.stringify(settings);
	localStorage.setItem(PM_SETTINGS_KEY, settingsString);
};
